import React from 'react'
import Navbar from '../../../Components/Navbar/Navbar'
import HeroPP from './HeroPP'
import PrivacyPolicyContent from './privacy-policy-content'
import Footer from '../../../Components/Footer/Footer';

const PrivacyPolicy = () => {
  return (
    <div>
        <Navbar></Navbar>
        <HeroPP></HeroPP>
        <PrivacyPolicyContent></PrivacyPolicyContent>
        <Footer></Footer>
        
    </div>
  )
}

export default PrivacyPolicy